import aboutImg from '../images/about.jpeg';
import Title from './Title';

const About = () => {
  return (
    <section className='section' id='about'>
      <Title title='about' subTitle='us' />

      <div className='section-center about-center'>
        <div className='about-img'>
          <img src={aboutImg} className='about-photo' alt='awesome beach' />
        </div>
        <article className='about-info'>
          <h3>Simplifying Compliance for You</h3>
          <p>
          At Smart Compliance, we simplify the complex world of legal and regulatory compliance. Our platform allows users to upload documents — such as PDFs and Word files — and instantly assess their compliance with applicable laws, policies, and industry standards. We not only provide a clear compliance score but also help you track and manage necessary follow-up actions to stay fully compliant.
          </p>
          <p>
          Our mission is to make compliance easy, transparent, and actionable for businesses of all sizes. With Smart Compliance, you can focus on what matters most — growing your business with confidence.
          </p>
          <a href='#' className='btn'>
            read more
          </a>
        </article>
      </div>
    </section>
  );
};
export default About;
